import { defectStatisRequest } from '@/network/requests/defectStatis'
import { getDefectRequest } from '@/network/requests/defect'
import { defect_statis } from '@/interfaces/defect_statis'

// 查出指定批次的缺陷
async function defectOfDefectStatis(defectStatisId: string) {
	const defectRequest = getDefectRequest(defectStatisId)
	try {
		return await defectRequest.queryAll(undefined, { insp_count: 1, bad_count: 1, meter: 1, size_cx: 1 }, { meter: 1 }, 1000)
	} catch (e) {
		return []
	}
}

/**
 * 指定批次集合，查询良率随米数的变化情况
 * @param defectStatisList 批次集合，必须包含属性：Insp_count，bad_count，total_len，bad_len_printer
 */
export async function getMeterYieldByDefectStatisList(defectStatisList: defect_statis[]) {
	// 对于每个批次，查询它们的缺陷
	const orderDefectList = await Promise.all(
		defectStatisList.map(async dfs => {
			const defectStatisId = dfs._id!.$oid
			const defectList = await defectOfDefectStatis(defectStatisId)
			return {
				defectStatisId,
				defectList,
				defectStatis: {
					Insp_count: dfs.Insp_count,
					bad_count: dfs.bad_count,
					total_len: dfs.total_len,
					bad_len_printer: dfs.bad_len_printer,
				},
				prevTotalLen: 0, // 前面所有批次总的生产长度
				produceLen: 0, // 当前批次的总生产长度
				prevTotalInsp: 0, // 前面所有批次的总检查张数
				inspCount: 0, // 当前批次的总检查张数
				prevTotalBadCount: 0, // 前面所有批次的总坏张数
				badCount: 0, // 当前批次的总坏张数
				prevTotalBadLength: 0, // 前面所有批次的总缺陷长度
				badLength: 0, // 当前批次的总缺陷长度
			}
		})
	)
	let meterYieldList: any[] = []
	for (let i = 0, j = -1; i < orderDefectList.length; i++, j++) {
		const prev = orderDefectList[j] // 前一批次
		const curr = orderDefectList[i] // 当前批次
		if (prev) {
			const { prevTotalLen, produceLen, prevTotalInsp, prevTotalBadCount, inspCount, badCount, prevTotalBadLength, badLength } = prev
			curr.prevTotalLen = prevTotalLen + produceLen
			curr.prevTotalBadCount = prevTotalBadCount + badCount
			curr.prevTotalInsp = prevTotalInsp + inspCount
			curr.prevTotalBadLength = prevTotalBadLength + badLength
		}
		const { defectList } = curr
		if (defectList.length === 0) {
			// 没有当前批次的缺陷数据
			curr.produceLen = curr.defectStatis.total_len || 0
			curr.inspCount = curr.defectStatis.Insp_count || 0
			curr.badCount = curr.defectStatis.bad_count || 0
			curr.badLength = curr.defectStatis.bad_len_printer || 0
		}
		meterYieldList = meterYieldList.concat(
			defectList.map(defect => {
				curr.produceLen = defect.meter || 0
				curr.inspCount = defect.insp_count || 0
				curr.badCount = defect.bad_count || 0
				curr.badLength += defect.size_cx || 0
				const totalLength = curr.produceLen + curr.prevTotalLen // 生产米数
				const totalBadLength = curr.badLength + curr.prevTotalBadLength // 总缺陷米数
				const totalBadCount = curr.badCount + curr.prevTotalBadCount // 总缺陷数量
				const totalInspCount = curr.inspCount + curr.prevTotalInsp // 总检查数
				const meterYield = {
					meter: totalLength,
					yieldOfMeter: 1 - totalBadLength / totalLength || 0,
					yieldOfSheet: 1 - totalBadCount / totalInspCount || 0,
				}
				return meterYield
			})
		)
	}
	const meterToYield: any = {}
	for (const meterYield of meterYieldList) {
		const { meter } = meterYield
		meterToYield[meter] = meterYield
	}
	return Object.values(meterToYield).sort((a: any, b: any) => a.meter - b.meter)
}

/**
 * 指定工单，查询良率随米数的变化情况
 */
export async function getMeterYieldByJobOrderId(job_order_id: string) {
	// 查询工单的全部批次
	const defectStatisList = await defectStatisRequest.queryAll({ job_order_id }, { total_len: 1, Insp_count: 1, bad_count: 1 }, { _id: 1 })

	return await getMeterYieldByDefectStatisList(defectStatisList)
}
